import { z } from 'zod';
export const permissionSlugSchema = z
    .string()
    .regex(/^[a-z][a-z0-9_]*\.[a-z0-9_.]+$/, 'Permission slug must be of the form "domain.resource.action" (lowercase, numbers, underscores, dots only).');
export const roleSlugSchema = z
    .string()
    .min(1)
    .max(64)
    .regex(/^[a-z][a-z0-9_-]*$/, 'Role slug must start with a letter and contain only lowercase letters, numbers, underscores, and hyphens.');
const RESERVED_ROLE_SLUGS = new Set(['super_user', 'org_admin', 'member']);
export const customRoleSlugSchema = roleSlugSchema.refine((slug) => !RESERVED_ROLE_SLUGS.has(slug), {
    message: 'Role slug collides with a built-in role (super_user, org_admin, member).',
});
export const createRoleSchema = z.object({
    slug: customRoleSlugSchema,
    name: z.string().min(1).max(255),
    permissions: z.array(permissionSlugSchema).default([]),
});
/**
 * Controller-layer schema for the POST /roles request body.
 *
 * Uses `roleSlugSchema` (not `customRoleSlugSchema`) so that reserved built-in
 * slugs pass Zod validation and are caught by `Role.createCustom` in the domain
 * layer, which throws `ReservedSlugError`. The interface filter then maps that
 * to a stable 400 `reserved_slug` code (organization-isolation Finding 4 / CC-3).
 * Unknown keys are stripped silently — `isBuiltIn` cannot be injected.
 */
export const createRoleRequestSchema = z.object({
    slug: roleSlugSchema,
    name: z.string().min(1).max(255),
    permissions: z.array(permissionSlugSchema).default([]),
});
export const replaceRolePermissionsSchema = z.object({
    permissions: z.array(permissionSlugSchema),
});
//# sourceMappingURL=authz.js.map